import { ActiveRequestsPage, PastRequestsPage } from "pages/RequestIndex";
import { useFeatureFlags } from "swing-components";

import { RequestIndexPage as RequestIndexPageType } from "~components/Organisms/IndexFiltersV2/types";

import { RequestIndexPage } from "./RequestIndexPage";

/**
 * Picks the whole request index page off a LaunchDarkly flag, rather than
 * conditionally swapping filter components inside a shared page.
 *
 * Once `adminRequestIndexV2` is fully rolled out, `pages/RequestIndex` and
 * `components/Organisms/IndexFilters` can be deleted and the routes pointed
 * straight at `RequestIndexPage`.
 */
function RequestIndexRoute(props: { page: RequestIndexPageType }) {
  const { page } = props;

  const { flags } = useFeatureFlags();

  if (flags.adminRequestIndexV2) return <RequestIndexPage page={page} />;

  return page === "active" ? <ActiveRequestsPage /> : <PastRequestsPage />;
}

export function ActiveRequestsRoute() {
  return <RequestIndexRoute page="active" />;
}

export function PastRequestsRoute() {
  return <RequestIndexRoute page="past" />;
}
